import React, { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import {
  errorMessage,
  forgetPassword,
  forgetPasswordContainer,
  subtitleContainer,
  subtitle1,
  subtitle2,
  content,
} from "./Login.style";
import { useNavigate } from "react-router-dom";
import ButtonLoading from "../components/ButtonLoading";
import { sendEmailResetPassword } from "../api/user";
import Input from "../components/Input";
import { toast } from "react-toastify";
import AuthSidePanel from "../components/AuthSidePanel";
import { colors } from "../utils/constants";

export default function ForgetPassword() {
  const [email, setEmail] = useState("");

  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);

  let navigate = useNavigate();

  const resetPassword = async (e: any) => {
    e.preventDefault();

    setLoading(true);

    sendEmailResetPassword(email)
      .then(async (response) => {
        toast.success("E-mail enviado para reset de senha.");
        navigate("/login");
        setLoginError(false);
      })
      .catch((e) => {
        toast.error("Erro ao enviar e-mail para reset de senha.");
        setLoginError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box style={styles.container}>
      <CssBaseline />

      <AuthSidePanel
        headline="Esqueceu sua senha? Sem problemas."
        subtext="Informe seu e-mail e enviamos um link para você criar uma nova senha."
      />

      <Box sx={content}>
        <Box style={styles.formCol}>
          <Box sx={subtitleContainer}>
            <span style={subtitle1}>Reset de senha</span>
            <span style={subtitle2}>
              Preencha o e-mail para resetar a senha
            </span>
          </Box>

          <Box component="form" onSubmit={resetPassword} style={styles.form}>
            <Input
              title={"E-MAIL"}
              placeholder={"E-mail"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />

            {loginError && (
              <span style={errorMessage}>
                Erro ao realizar login. Verifique seus dados e tente novamente.
              </span>
            )}

            <ButtonLoading
              label="Enviar e-mail"
              loading={loading}
              className="landing-hover-lift"
              style={styles.primaryButton}
            />

            <div style={{ ...forgetPasswordContainer, textAlign: "center" }}>
              <Link href="/login" variant="body2" style={forgetPassword}>
                Voltar para login
              </Link>
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const styles: any = {
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "row",
  },

  formCol: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  form: {
    marginTop: 8,
    width: "100%",
    maxWidth: 420,
    padding: 0,
  },

  primaryButton: {
    marginTop: 24,
    width: "100%",
    height: 52,
    borderRadius: 100,
    color: colors.white,
  },
};
